// CORS Headers Configuration for API requests
// This utility provides standardized headers for all API calls to ensure proper CORS handling

const getCorsHeaders = (additionalHeaders = {}) => {
  const baseHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With, Accept, Origin',
    'Access-Control-Allow-Credentials': 'true'
  };

  // Add browser-specific headers if needed
  const browserHeaders = {
    'sec-ch-ua': '"Google Chrome";v="137", "Chromium";v="137", "Not/A)Brand";v="24"',
    'sec-ch-ua-mobile': '?0',
    'sec-ch-ua-platform': '"macOS"'
  };

  // Merge headers with any additional headers passed in
  return {
    ...baseHeaders,
    ...browserHeaders,
    ...additionalHeaders
  };
};

// Headers specifically for preflight OPTIONS requests
const getPreflightHeaders = () => {
  return {
    'Access-Control-Request-Method': 'POST',
    'Access-Control-Request-Headers': 'Content-Type, Authorization',
    'Origin': window.location.origin || 'https://yobi.vip'
  };
};

// Headers for authenticated requests
const getAuthHeaders = (token, additionalHeaders = {}) => {
  return getCorsHeaders({
    'Authorization': `Bearer ${token}`,
    ...additionalHeaders
  });
};

// Export individual functions for different use cases
export {
  getCorsHeaders,
  getPreflightHeaders,
  getAuthHeaders
};

// Default export for basic CORS headers
export default getCorsHeaders;